import { render, staticRenderFns } from "./TicketsOverseasAwayReport.vue?vue&type=template&id=5716a148"
import script from "./TicketsOverseasAwayReport.vue?vue&type=script&lang=js"
export * from "./TicketsOverseasAwayReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports